type SMSReplyFact = {
	field: string
	label: string
	estimatedCharacters: number
}

type SMSReplyBudget = {
	limit: number
	reserved: number
	remaining: number
	overBudget: boolean
}

const SMS_SEGMENT_LIMIT = 160
const SMS_MULTIPART_SEGMENT_LIMIT = 153

// What the send route rejects past, mirroring composer's sms reply editor.
const SMS_MAX_CHARACTERS = 320

// The route counts runes, so an emoji costs one there and two to String.length.
// Counting the same way keeps the panel from allowing a reply the route refuses,
// or refusing one it would have taken.
function characterCount(text: string): number {
	return [...text].length
}

const SMS_REPLY_FACTS: SMSReplyFact[] = [
	{field: "customer_name", label: "Name", estimatedCharacters: 12},
	{field: "outstanding_balance", label: "Balance", estimatedCharacters: 10},
	{field: "last_payment_amount", label: "Last payment amount", estimatedCharacters: 14},
	{field: "last_payment_date", label: "Last payment date", estimatedCharacters: 14},
	{field: "original_creditor", label: "Original creditor", estimatedCharacters: 22},
	{field: "payment_portal_link", label: "Payment link", estimatedCharacters: 28},
]

function reservedCharacters(fields: string[]): number {
	return fields.reduce((total, field) => {
		const fact = SMS_REPLY_FACTS.find((candidate) => candidate.field === field)
		return total + (fact?.estimatedCharacters ?? 0)
	}, 0)
}

function replyBudget(fields: string[], limit = SMS_SEGMENT_LIMIT): SMSReplyBudget {
	const reserved = reservedCharacters(fields)
	return {
		limit,
		reserved,
		remaining: Math.max(limit - reserved, 0),
		overBudget: reserved > limit,
	}
}

// A message inside one segment gets all 160 characters. Longer messages are
// split by the carrier into concatenated parts, each spending 7 characters on
// the header that reassembles them.
function segmentCount(text: string): number {
	const characters = characterCount(text)
	if (characters === 0) return 0
	if (characters <= SMS_SEGMENT_LIMIT) return 1
	return Math.ceil(characters / SMS_MULTIPART_SEGMENT_LIMIT)
}

export {
	SMS_SEGMENT_LIMIT,
	SMS_MAX_CHARACTERS,
	SMS_REPLY_FACTS,
	characterCount,
	reservedCharacters,
	replyBudget,
	segmentCount,
}
export type {SMSReplyFact, SMSReplyBudget}
